export default __webpack_public_path__ + "static/media/contact_border.b5a0d3e3.jpg";